import { fetchFromObject } from 'helpers/object';

export default {
  getGuideField: state => field => fetchFromObject(state, field)
};
